import classNames from 'classnames';
import GloLayout from 'lowcode/common/GloLayout';
import { useEffect, useRef, useState } from 'react';
import './index.scss';
export default function Content({ id, data = {} }: any) {
    const { href, widthLayout, imgPosition, widthPc } = data;
    const prefixCls = 'editor-blog-youtube';
    const classes = classNames(prefixCls, {
        [`${prefixCls}-widthLayout-${widthLayout}`]: widthLayout,
        [`${prefixCls}-imgPosition-${imgPosition}`]: imgPosition,
    });
    const compStyle = {
        '--editor-blog-youtube-w': `${widthPc}px`,
    };
    const refCompBox = useRef<any>(null);
    const [isShow, setIsShow] = useState(false);
    useEffect(() => {
        const options = {
            rootMargin: '100px', //偏移量,-100px表示从底部伸出100px了
            threshold: 0, //0 - 1;0表示监听元素有部分进入了可视区
        };

        const observer = new IntersectionObserver((entries) => {
            const elem = entries[0];
            if (elem.isIntersecting && elem.boundingClientRect.top > 0) {
                //console.log("enter", "从底部进入");
                setIsShow(true);
            } else if (elem.isIntersecting && elem.boundingClientRect.top < 0) {
                //console.log("enter", "从顶部进入");
                setIsShow(true);
            } else if (!elem.isIntersecting && elem.boundingClientRect.top > 0) {
                //console.log("leave", "从底部离开");
            } else {
                //console.log("leave", "从顶部离开");
            }
        }, options);
        if (refCompBox.current) {
            observer.observe(refCompBox.current);
        }
    }, []);
    if (!href) {
        return null;
    }
    return (
        <GloLayout className={classes} id={id} style={compStyle}>
            <div className={`${prefixCls}-content`} ref={refCompBox}>
                {isShow && <iframe src={href} className="editor-blog-youtube-iframe"></iframe>}
            </div>
        </GloLayout>
    );
}
